export default __webpack_public_path__ + "static/media/Cadeaux.c54d8901.xlsx";